export default __webpack_public_path__ + "static/media/withdraw-epoint-step2.c8d5c842.png";